import { Component } from '@angular/core';
import { ErrorPageComponent } from '../error-page/error-page.component';

@Component({
    selector: 'app-error-404',
    standalone: true,
    imports: [ErrorPageComponent],
    templateUrl: './error-404.component.html'
})
export class Error404Component {

}
